
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.688 24.005a1.502 1.502 0 01-1.35-.845l-1.773-2.794-2.701-1.524a1.489 1.489 0 01-.865-1.361c0-.401.156-.777.44-1.059l1.521-1.394a2.263 2.263 0 011.84-.584l1.106-.016L8.89 9.913 3.354 6.59a2.235 2.235 0 01-1.093-1.93c0-.601.234-1.166.659-1.591l.684-.684A2.266 2.266 0 015.768 1.8l8.826 2.322 3.025-3.026A3.72 3.72 0 0120.902.05a3.72 3.72 0 012.429 1.529 3.862 3.862 0 01-.535 4.946l-2.9 2.9 2.323 8.828c.203.771-.021 1.6-.585 2.163l-.685.685a2.244 2.244 0 01-1.587.657 2.263 2.263 0 01-1.933-1.092l-3.307-5.512-4.382 4.097-.018 1.12a2.249 2.249 0 01-.684 1.96l-1.306 1.245a1.48 1.48 0 01-.455.304 1.435 1.435 0 01-.589.125zm-5.115-6.486l2.893 1.632a.753.753 0 01.265.252l1.9 2.995a.8.8 0 01.055.104l1.323-1.259a.752.752 0 00.227-.683.714.714 0 01-.012-.146l.024-1.506a.75.75 0 01.238-.535l5.292-4.948a.75.75 0 011.156.162l3.785 6.308a.757.757 0 00.646.364.744.744 0 00.53-.221l.683-.683a.753.753 0 00.195-.721L18.34 9.39a.751.751 0 01.195-.721l3.217-3.217c.838-.801.981-2.07.347-3.024a2.217 2.217 0 00-1.445-.899 2.226 2.226 0 00-1.97.627l-3.33 3.331a.753.753 0 01-.722.195L5.387 3.251a.753.753 0 00-.721.195l-.685.684a.744.744 0 000 1.06.724.724 0 00.145.113l6.308 3.785a.748.748 0 01.177 1.139l-4.8 5.44a.754.754 0 01-.552.254l-1.504.022a.787.787 0 01-.138-.011.76.76 0 00-.637.194L1.501 17.48l.072.039z"}})])
          )
        }
      }
    